import React from 'react';
import { Package, Sparkles } from 'lucide-react';

const RelatedCard = ({ product, slug, accentColor, formatPrice, navigate, theme }) => {
  const hasImage = product.images && product.images.length > 0;
  const imageUrl = hasImage ? product.images[0].url : null;
  
  return (
    <button 
      className="text-left rounded-xl overflow-hidden transition-all group hover:shadow-md"
      style={{ backgroundColor: theme.cardBg, border: `1px solid ${theme.borderColor}` }}
      onClick={() => navigate(`/s/${slug}/p/${product.id}`)}
      data-testid={`related-product-${product.id}`}
    >
      <div className="aspect-square overflow-hidden" style={{ opacity: 0.9 }}>
        {imageUrl ? (
          <img 
            src={`${process.env.REACT_APP_BACKEND_URL}${imageUrl}`}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center" style={{ opacity: 0.3 }}>
            <Package className="w-10 h-10" />
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-medium text-sm line-clamp-2 mb-1">{product.name}</h3>
        {formatPrice(product.priceCents) && (
          <p className="text-sm font-bold" style={{ color: accentColor }}>{formatPrice(product.priceCents)}</p>
        )}
      </div>
    </button>
  );
};

const RelatedSection = ({ products, slug, accentColor, formatPrice, navigate, theme }) => {
  if (products.length === 0) return null;
  
  return (
    <section className="py-10 mb-20 lg:mb-4" style={{ borderTop: `1px solid ${theme.borderColor}` }} data-testid="related-products">
      <div className="flex items-center gap-2.5 mb-6">
        <Sparkles className="w-5 h-5" style={{ color: accentColor }} />
        <h2 className="text-xl font-bold">Vous aimerez aussi</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {products.map(p => (
          <RelatedCard key={p.id} product={p} slug={slug} accentColor={accentColor} formatPrice={formatPrice} navigate={navigate} theme={theme} />
        ))}
      </div>
    </section>
  );
};

export default RelatedSection;
